import { notification } from 'antd';
const Utility = {
    openNotification 
}
function openNotification(type,placement, message, description) {
    
    notification[type]({
        message: `${message}`,
        description: description,
        placement,
        
    });
};
export default Utility  

const notifyType = Object.freeze({
    error:'error',
    warn:'warn',
    success:'success',
    info:'info',    
});
const notifyPlacement = Object.freeze({
    bottomRight:'bottomRight',
    bottomLeft:'bottomLeft',
    topLeft:'topLeft',
    topRight:'topRight',    
});
export {notifyType,notifyPlacement}